import React from "react";
import styled from "styled-components";
import { RightArrowAlt } from '@styled-icons/boxicons-regular';

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    text-align: center;
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const LeftImage = styled.img`
    width: 392px;
    height: 392px;
    margin-right: 25px;
    @media (max-width: 767px){
        height: 339px;
        width: auto;
        margin: 0;
    }
    @media (min-width: 768px) and (max-width: 800px){
        margin: 0;
    }
    @media (min-width: 768px){
        &:hover {
            opacity: 0.2;
        }
    }
`;

export const RightImage = styled.img`
    width: 392px;
    height: 392px;
    @media (max-width: 767px){
        height: 339px;
        width: auto;
    }
`;

export const Text = styled.p`
    color: #212323;
    font-family: Mallory;
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 22px;
    @media (max-width: 767px){
        max-width: 177px;
        margin-top: 0;
        text-align: left;
    }
`;

export const Row = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const Relative = styled.div`
    position: relative;
    text-align: center;
    cursor: pointer;
`;

export const Absolute = styled.div`
    position: absolute;
    top: 25px;
    left: 32px;
    text-align: left;
    @media (max-width: 767px){
        display: none;
    }
`;

export const Link = styled.a`
    color: #070808;
    font-family: Mallory;
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 16px;
    text-decoration: none;
    @media (max-width: 767px){
        margin-left: auto;
    }
`;

export const Overlay = styled.div`
    width: 392px;
    height: 392px;
    position: absolute;
    top: 0;
    color: gray;
    background-color: rgb(242 242 242 / 50%);
    @media (max-width: 767px){
        height: 339px;
        width: auto;
        display: none;
    }
`;

export const AbsoluteMobile = styled.div`
    @media (max-width: 767px){
        bottom: 30px;
        top: auto;
        display: flex;
        align-items: flex-start;
        margin-top: 20px;
        width: 339px;
        margin: 15px 18px;
    }
    @media (min-width: 768px){
        display: none
    }
`;